export const getFormattedAmount = new Intl.NumberFormat("en-NG", {
    style: "currency",
    currency: "NGN",
});